import { render, staticRenderFns } from "./required-documents-view.vue?vue&type=template&id=158e0999"
import script from "./required-documents-view.vue?vue&type=script&lang=js"
export * from "./required-documents-view.vue?vue&type=script&lang=js"
import style0 from "./required-documents-view.vue?vue&type=style&index=0&id=158e0999&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports